import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=135c18ef&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c18ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135c18ef')) {
      api.createRecord('135c18ef', component.options)
    } else {
      api.reload('135c18ef', component.options)
    }
    module.hot.accept("./SignDialog.vue?vue&type=template&id=135c18ef&scoped=true", function () {
      api.rerender('135c18ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SignDialog/SignDialog.vue"
export default component.exports